<template>
  <v-app id="app">
    <v-main class="page">
      <v-container fluid class="temp-container">
        <router-view />
      </v-container>
    </v-main>

    <LateralMenu v-if="_showFilter" />

    <div class="sync-language-menu-anchor">
      <LanguageMenu />
    </div>
  </v-app>
</template>
<script>
import LateralMenu from './views/LateralMenu/LateralMenu.vue'
import LanguageMenu from '@/components/LanguageMenu/LanguageMenu.vue'
import { projectAuth } from '@/firebase/config'
import { applyLanguage, resolveSessionLocale } from '@/helpers/locale'

export default {
  name: 'SyncApp',

  components: {
    LateralMenu,
    LanguageMenu,
  },

  computed: {
    _showFilter() {
      const routes = ['ImportedPeoplePage', 'ImportedGroupsPage']

      return routes.includes(this.$route.name)
    },
  },

  data: () => ({
    isSignedin: false,
  }),

  created() {
    this.isSignedin = false
    const $router = this.$router
    projectAuth.onAuthStateChanged(async user => {
      if (user) {
        this.isSignedin = true
        await this.syncUserLanguage(user)
        if (window.location.href.includes('login')) {
          $router.push('/')
        }
      } else {
        this.isSignedin = false
      }
    })
  },

  methods: {
    async syncUserLanguage(user) {
      const locale = await resolveSessionLocale(user)
      if (locale) {
        applyLanguage(this.$root.$i18n, locale, this.$vuetify)
      }
    },
  },
}
</script>

<style lang="scss">
#app {
  display: flex;
}
.temp-container {
  height: 100%;
  padding: inherit !important;
}
</style>

<style lang="scss" scoped>
/*
 * Anchor fixo do LanguageMenu — canto inferior ESQUERDO em todas as rotas.
 * O LateralMenu (v-navigation-drawer) ocupa a borda direita, então o canto
 * esquerdo não interfere com ele; o dropdown do menu abre para cima/direita
 * (top + offset-x), compatível com esta posição.
 */
.sync-language-menu-anchor {
  position: fixed;
  left: 1rem;
  bottom: 1rem;
  z-index: 100;

  background-color: #ffffff;
  border: 1px solid #dadee3;
  border-radius: 50%;
  box-shadow: 0 0.125rem 0.625rem rgba(0, 0, 0, 0.08);
}
</style>
